<table class="card-box-table">
  <caption>
    <div class="d-flex flex-column flex-md-row justify-content-center align-items-center justify-content-md-between">
      <span>
        <span class="caption-title">{{ header | translate }} ({{ totalRows }}/{{ total }})</span>
        <span class="caption-left-actions ml-2">
          <ng-content select="[table-left-action]"></ng-content>
        </span>
      </span>

      <span class="caption-right-actions ml-0 ml-md-2 mt-2 mt-md-0">
        <ng-content select="[table-right-action]"></ng-content>
      </span>
    </div>
  </caption>
  <thead>
    <tr>
      <th class="col-name">{{ "LABELS.NAME" | translate }}</th>
      <th class="col-route">{{ "LABELS.ROUTE" | translate }}</th>
      <th class="col-storage">{{ "LABELS.DEPARTURE_STORAGE" | translate }}</th>
      <th class="col-storage">{{ "LABELS.ARRIVAL_STORAGE" | translate }}</th>
      <th class="col-status">{{ "LABELS.STATUS" | translate }}</th>
      <th class="col-publishing-state">{{ "LABELS.PUBLISHING_STATE" | translate }}</th>
      <th class="col-date">{{ "LABELS.LAST_MODIFIED" | translate }}</th>
      <th class="col-actions"></th>
    </tr>
  </thead>
  <tbody>
    <tr *ngIf="total === 0" class="disabled">
      <td [colSpan]="8">{{ "LABELS.EMPTY_LIST" | translate }}</td>
    </tr>
    <tr *ngFor="let voyage of voyageList$ | async | paginate : { id: tableId, itemsPerPage: limit, currentPage: page, totalItems: total }">
      <td class="col-route" [attr.data-label]="'LABELS.NAME' | translate" [title]="voyage?.displayName || ''">
        <a [routerLink]="['/voyages-management-v1', voyage.id]">
          {{ voyage?.displayName }}
        </a>
      </td>
      <td
        class="col-route"
        [attr.data-label]="'LABELS.ROUTE' | translate"
        [title]="voyage?.route?.displayName ? voyage?.route?.displayName : ''"
      >
        <a *ngIf="voyage?.route && linkToRoute" [routerLink]="['/routes-management', voyage.route.id]">
          {{ voyage.route.displayName }}
        </a>
        <span *ngIf="voyage?.route && !linkToRoute">{{ voyage.route.displayName }}</span>
      </td>
      <td
        class="col-storage"
        [attr.data-label]="'LABELS.DEPARTURE_STORAGE' | translate"
        [title]="voyage?.departureStorage?.displayName ? voyage.departureStorage.displayName : ''"
      >
        <a *ngIf="voyage?.departureStorage" [routerLink]="['/container-freight-storages-management', voyage.departureStorage.id]">
          {{ voyage.departureStorage.displayName }}
        </a>
      </td>
      <td
        class="col-storage"
        [attr.data-label]="'LABELS.ARRIVAL_STORAGE' | translate"
        [title]="voyage?.arrivalStorage?.displayName ? voyage.arrivalStorage.displayName : ''"
      >
        <a *ngIf="voyage?.arrivalStorage" [routerLink]="['/container-freight-storages-management', voyage.arrivalStorage.id]">
          {{ voyage.arrivalStorage.displayName }}
        </a>
      </td>
      <td
        class="col-status"
        [attr.data-label]="'LABELS.STATUS' | translate"
        [title]="'VOYAGE_STATUS.' + enumVoyageStatus[voyage.status] | translate"
      >
        {{ "VOYAGE_STATUS." + enumVoyageStatus[voyage.status] | translate }}
      </td>
      <td
        class="col-publishing-state"
        [attr.data-label]="'LABELS.PUBLISHING_STATE' | translate"
        [title]="'PUBLISHING_STATE.' + enumPublishingState[voyage.publishingState] | translate"
      >
        {{ "PUBLISHING_STATE." + enumPublishingState[voyage.publishingState] | translate }}
      </td>
      <td
        class="col-date"
        [attr.data-label]="'LABELS.LAST_MODIFIED' | translate"
        [title]="voyage.modificationData.modifiedDate | customDateTimeByUtc"
      >
        {{ voyage.modificationData.modifiedDate | customDateTimeByUtc }}
      </td>
      <td class="col-actions">
        <dropdown-action [menuMode]="menuMode" [id]="'actions'" [className]="null">
          <button dropdown-item type="button" class="dropdown-item" [routerLink]="['/voyages-management-v1', voyage.id]">
            {{ "BUTTON.VIEW" | translate }}
          </button>
          <button dropdown-item type="button" class="dropdown-item" *ngIf="canDuplicate" (click)="duplicate.emit(voyage.id)">
            {{ "BUTTON.DUPLICATE" | translate }}
          </button>
          <button
            *ngIf="canEdit"
            dropdown-item
            type="button"
            class="dropdown-item"
            [routerLink]="['/voyages-management-v1', voyage.id, 'edit']"
          >
            {{ "BUTTON.EDIT" | translate }}
          </button>
          <button *ngIf="canDelete" dropdown-item type="button" class="dropdown-item" (click)="delete.emit(voyage.id)">
            {{ "BUTTON.DELETE" | translate }}
          </button>
        </dropdown-action>
      </td>
    </tr>
    <loading-spinner [show]="isLoading"></loading-spinner>
  </tbody>
  <tfoot>
    <tr>
      <td [colSpan]="8">
        <div class="d-flex justify-content-between align-items-center flex-wrap">
          <div class="py-2">
            <ng-template [ngIf]="totalRows">{{ "LABELS.TOTAL_ROWS" | translate }}: {{ totalRows }}/{{ total }}</ng-template>
          </div>
          <div class="py-2 mx-2 d-flex">
            <ng-select
              id="page-limit"
              class="custom"
              [items]="[20, 50, 100]"
              [clearable]="false"
              [ngModel]="limit"
              (ngModelChange)="limitChanged.emit($event)"
            ></ng-select>
            <ng-template [ngIf]="total > limit">
              <pagination-controls
                class="custom-pagination"
                [id]="tableId"
                [maxSize]="paginationMaxSize$ | async"
                [previousLabel]="'LABELS.PREVIOUS' | translate"
                [nextLabel]="'LABELS.NEXT' | translate"
                (pageChange)="onPageChange($event)"
                (pageBoundsCorrection)="onPageChange($event)"
              ></pagination-controls>
            </ng-template>
          </div>
        </div>
      </td>
    </tr>
  </tfoot>
</table>
